module.exports = __webpack_public_path__ + "static/media/tinywow_2434AmbrosiapollenaufNarbe_colored_55475442.34cfe2ee.jpg";